import { useEffect, useState } from "react";
import Layout from "../Components/Reuseable/layout";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
// import images from "../assets/registration.png";
import Logo from "../assets/logo-resizr.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DatePicker } from "antd";
import { BsEye, BsEyeSlash, BsArrowLeft } from "react-icons/bs";
import { Country_Name } from "../Components/Reuseable/Country";
import authBg from "../../Webiste/assets/Auth/auth_bg.jpg";
import { getBaseUrl } from "../service/apiUrl";
const RegisterScreen = () => {
  const dispatch = useDispatch();
  const cookiedata = Cookies.get("i18next");
  const { t } = useTranslation();
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [passwordMatch, setpasswordMatch] = useState(false);
  const [profileNumberData, setprofileNumberData] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const togglePasswordVisiblity = () => setPasswordShown(!passwordShown);
  const toggleConfirmPasswordVisiblity = () =>
    setConfirmPasswordShown(!confirmPasswordShown);

  const [formValues, setFormValues] = useState({
    FirstName: "",
    LastName: "",
    PassportNo: "",
    password: "",
    PhoneNumber: "",
    Email: "",
    Address: "",
    NationalityID: "",
    DOB: "",
    errors: {},
  });

  const {
    FirstName,
    LastName,
    Email,
    Address,
    NationalityID,
    PhoneNumber,
    DOB,
  } = formValues;

  const [passportNumber, setPassportNumber] = useState("");
  const [isValidPassport, setIsValidPassport] = useState(true);

  const handlePassportNumberChange = (e) => {
    const newValue = e.target.value;
    setPassportNumber(newValue);
    const passportNumberPattern = /^[A-Z0-9]{6,15}[A-Z]*$/;
    setIsValidPassport(passportNumberPattern.test(newValue));
  };

  const [state, setState1] = useState({ Password: "", ConfirmPassword: "" });
  const [passwordError, setPasswordError] = useState("");
  const [DOBData, setDOBData] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setState1({ ...state, Password: newPassword });
    if (newPassword.length < 6) {
      setPasswordError(t("Password must be at least 6 characters"));
    } else {
      setPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setState1({ ...state, ConfirmPassword: newConfirmPassword });
    if (newConfirmPassword !== state.Password) {
      setpasswordMatch(true);
      setConfirmPasswordError(t("Passwords do not match"));
    } else {
      setConfirmPasswordError("");
      setpasswordMatch(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const [PassportPicture, setPassportPicture] = useState();
  const [ProfilePicture, setProfilePicture] = useState();
  const [preview, setPreview] = useState();
  const [preview1, setPreview1] = useState();

  const onSelectFileProfile = (e) => setProfilePicture(e.target.files[0]);
  const onSelectFilePassport = (e) => setPassportPicture(e.target.files[0]);

  const navigate = useNavigate();

  useEffect(() => {
    if (!ProfilePicture) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(ProfilePicture);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [ProfilePicture]);

  useEffect(() => {
    if (!PassportPicture) {
      setPreview1(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(PassportPicture);
    setPreview1(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [PassportPicture]);

  const [validated, setValidated] = useState(false);

  const showToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  const onChange = (date, dateString) => {
    setDOBData(dateString);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // Check validity
    if (form.checkValidity() === false || passwordMatch === true) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else if (isValidPassport) {
      try {
        const formData = new FormData();
        formData.append("FirstName", FirstName);
        formData.append("LastName", LastName);
        formData.append("PassportNo", passportNumber);
        formData.append("PhoneNumber", PhoneNumber);
        formData.append("password", state.Password);
        formData.append("Email", Email);
        formData.append(
          "Nationality",
          NationalityID === "" ? "United Arab Emirates" : NationalityID,
        );
        formData.append("Address", Address);
        formData.append("DOB", DOBData);
        formData.append("PassportPicture", PassportPicture);
        formData.append("ProfilePicture", ProfilePicture);

        const res = await axios.post(`${getBaseUrl()}/register`, formData);
        Cookies.set("token", res.data.token);
        navigate("/verifyemail");
      } catch (error) {
        showToast(error?.response?.data?.message);
      }
    }
  };

  const removeImagePreview = () => {
    setProfilePicture(null);
    setPreview();
  };
  const removeImagePassPreview = () => {
    setPassportPicture(null);
    setPreview1();
  };

  return (
    <div
      className="saddle-unique-wrapper"
      style={{
        backgroundImage: `linear-gradient(rgba(11,17,54,0.8), rgba(11,17,54,0.8)), url(${authBg})`,
      }}
    >
      <div className="sb-reg-container">
        {/* Header */}
        <div className="sb-reg-header">
          <div className="header-left">
            <Link to="/login" className="back-btn">
              <BsArrowLeft />
            </Link>
            <div className="title-box">
              <h3>{t("Create Account")}</h3>
              <p>{t("Be A Part of Saddle Battles")}</p>
            </div>
          </div>
          <div className="header-right">
            <img src={Logo} alt="Saddle Battles" className="sb-logo" />
          </div>
        </div>

        {/* Body */}
        <div className="sb-reg-body">
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="sb-grid">
              {/* First Name */}
              <div className="sb-group">
                <Form.Label>{t("FirstName")}</Form.Label>
                <div className="input-rel">
                  <Form.Control
                    name="FirstName"
                    type="text"
                    placeholder="E.G."
                    value={FirstName}
                    onChange={handleChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Please Provide First Name")}
                  </Form.Control.Feedback>
                </div>
              </div>

              {/* Last Name */}
              <div className="sb-group">
                <Form.Label>{t("LastName")}</Form.Label>
                <div className="input-rel">
                  <Form.Control
                    type="text"
                    placeholder="E.G."
                    value={LastName}
                    name="LastName"
                    onChange={handleChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Please Provide Last Name")}
                  </Form.Control.Feedback>
                </div>
              </div>

              {/* Email (Optional) */}
              <div className="sb-group">
                <Form.Label>
                  {t("Email")} <span className="opt-txt">{t("(Optional)")}</span>
                </Form.Label>
                <div className="input-rel">
                  <Form.Control
                    type="email"
                    placeholder="basipintercomtest@gmail.com"
                    value={Email}
                    name="Email"
                    onChange={handleChange}
                  />
                  {/* Removed required */}
                </div>
              </div>

              {/* Phone Number */}
              <div className="sb-group">
                <Form.Label>{t("PhoneNumber")}</Form.Label>
                <div className="input-rel">
                  <Form.Control
                    type="text"
                    name="PhoneNumber"
                    placeholder="+971"
                    onChange={handleChange}
                    value={PhoneNumber}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Please Provide Valid PhoneNumber.")}
                  </Form.Control.Feedback>
                </div>
              </div>

              {/* Password */}
              <div className="sb-group password-grp">
                <Form.Label>{t("password")}</Form.Label>
                <div className="input-rel pass-rel">
                  <Form.Control
                    value={state.Password}
                    onChange={handlePasswordChange}
                    type={passwordShown ? "text" : "password"}
                    placeholder='E.G., "@Abc!$%"'
                    required
                    className="password-input"
                  />
                  <span className="eye-btn" onClick={togglePasswordVisiblity}>
                    {passwordShown ? <BsEyeSlash /> : <BsEye />}
                  </span>
                </div>

                <div className="pass-error-msg">
                  <Form.Control.Feedback type="invalid">
                    {t("Please Provide Password.")}
                  </Form.Control.Feedback>
                </div>
                {passwordError && (
                  <small className="custom-err">{passwordError}</small>
                )}
              </div>

              {/* Confirm Password */}
              <div className="sb-group password-grp">
                <Form.Label>{t("Confirm Password")}</Form.Label>
                <div className="input-rel pass-rel">
                  <Form.Control
                    value={state.ConfirmPassword}
                    onChange={handleConfirmPasswordChange}
                    type={confirmPasswordShown ? "text" : "password"}
                    placeholder='E.G., "@Abc!$%"'
                    required
                    className="password-input"
                  />
                  <span
                    className="eye-btn"
                    onClick={toggleConfirmPasswordVisiblity}
                  >
                    {confirmPasswordShown ? <BsEyeSlash /> : <BsEye />}
                  </span>
                </div>
                <div className="pass-error-msg">
                  <Form.Control.Feedback type="invalid">
                    {t("Please Provide Confirm Password.")}
                  </Form.Control.Feedback>
                </div>
                {confirmPasswordError && (
                  <small className="custom-err">{confirmPasswordError}</small>
                )}
              </div>

              {/* Passport No */}
              <div className="sb-group">
                <Form.Label>{t("PassportNo")}</Form.Label>
                <div className="input-rel">
                  <Form.Control
                    type="text"
                    value={passportNumber}
                    name="PassportNo"
                    placeholder="Passport No"
                    onChange={handlePassportNumberChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Please Provide Valid PassportNo.")}
                  </Form.Control.Feedback>
                </div>
                {!isValidPassport && (
                  <small className="custom-err">{t("Invalid Format")}</small>
                )}
              </div>

              {/* Date Of Birth (Optional) */}
              <div className="sb-group">
                <Form.Label>
                  {t("DOB")}{" "}
                  <span className="opt-txt">{t("(Optional)")}</span>
                </Form.Label>
                <DatePicker
                  onChange={onChange}
                  className="sb-date"
                  placeholder="Select Date"
                />
              </div>

              {/* Nationality (Optional) */}
              <div className="sb-group">
                <Form.Label>
                  {t("Nationality")} <span className="opt-txt">{t("(Optional)")}</span>
                </Form.Label>
                <Form.Select
                  name="NationalityID"
                  value={NationalityID}
                  onChange={handleChange}
                  className="sb-select"
                >
                  {Country_Name.map((item, i) => (
                    <option key={i} value={item.country_name}>
                      {item.country_name}
                    </option>
                  ))}
                </Form.Select>
              </div>

              {/* Address (Optional) */}
              <div className="sb-group">
                <Form.Label>
                  {t("Address")} <span className="opt-txt">{t("(Optional)")}</span>
                </Form.Label>
                <Form.Control
                  name="Address"
                  type="text"
                  placeholder="Address"
                  value={Address}
                  onChange={handleChange}
                />
              </div>

              {/* Files (Optional) */}
              <div className="sb-group">
                <Form.Label>
                  {t("Profile Picture")}{" "}
                  <span className="opt-txt">{t("(Optional)")}</span>
                </Form.Label>
                <Form.Control
                  onChange={onSelectFileProfile}
                  type="file"
                  className="sb-file"
                />
                {ProfilePicture ? (
                  <div className="sb-prev">
                    <img src={preview} alt="" />
                    <i className="fa fa-times" onClick={removeImagePreview}></i>
                  </div>
                ) : (
                  <div className="no-file">{t("No file chosen")}</div>
                )}
              </div>

              <div className="sb-group">
                <Form.Label>
                  {t("Passport Picture")}{" "}
                  <span className="opt-txt">{t("(Optional)")}</span>
                </Form.Label>
                <Form.Control
                  onChange={onSelectFilePassport}
                  type="file"
                  className="sb-file"
                />
                {PassportPicture ? (
                  <div className="sb-prev">
                    <img src={preview1} alt="" />
                    <i
                      className="fa fa-times"
                      onClick={removeImagePassPreview}
                    ></i>
                  </div>
                ) : (
                  <div className="no-file">{t("No file chosen")}</div>
                )}
              </div>
            </div>

            {/* Terms */}
            <div className="sb-terms">
              <Form.Check
                type="checkbox"
                id="terms-check"
                required
                label={
                  <span>
                    {t("I Am Over 18 And Accept The Saddle Battles")}{" "}
                    <Link to="/terms" className="sb-link">
                      {t("Terms & Conditions.")}
                    </Link>
                  </span>
                }
                className="sb-chk"
              />
            </div>
            <div className="sb-action">
              <Button type="submit" className="sb-btn">
                {t("RegisterNow")}
              </Button>
            </div>
          </Form>
        </div>

        <div className="sb-footer">
          <p>
            {t("Already have an account?")}{" "}
            <Link to="/login" className="sb-link">
              {t("Sign In here")}
            </Link>
          </p>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} backdrop="static" centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <img src={profileNumberData} alt="" className="w-100" />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RegisterScreen;
